export default __webpack_public_path__ + "static/media/science.b34746d3.png";